import * as FromCalendar from 'reducers/calendar/selectors';

export const SLICE = 'calendar';

export const getTableSort = state => FromCalendar.getTableSort(state[SLICE]);
export const getFilter = id => state =>
  FromCalendar.getFilter(state[SLICE], id);
export const getFilters = state => FromCalendar.getFilters(state[SLICE]);
export const getRestoringState = state =>
  FromCalendar.getRestoringState(state[SLICE]);
